import styled, { css } from 'styled-components';

export const List = styled.ul<{
  $preventInteraction: boolean;
  $isMobileOutlined: boolean;
  $isFaded: boolean;
}>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  flex-wrap: wrap;

  min-width: 0;
  width: 0;
  padding: 0;
  margin: 0;

  list-style: none;

  ${({ $preventInteraction }) =>
    $preventInteraction &&
    css`
      pointer-events: none;
    `};

  ${({ theme, $isMobileOutlined }) =>
    theme.isMobile &&
    $isMobileOutlined &&
    css`
      gap: ${({ theme }) => theme.spacing(2)};
    `};

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.3;
    `};
`;

export const ListItem = styled.li<{
  $hasValue: boolean;
  $isMobileOutlined: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.75)};

  max-width: ${({ $hasValue }) => ($hasValue ? '100%' : '2.4rem')};

  transition: max-width 200ms;
  overflow: hidden;

  line-height: 62.5%;

  ${({ theme, $isMobileOutlined }) =>
    theme.isMobile &&
    css`
      min-width: ${$isMobileOutlined ? '3.8rem' : '2.4rem'};
    `};
`;
